import { createSlice } from '@reduxjs/toolkit'
import {defaultMenuType,  subHiddenBreakpoint, menuHiddenBreakpoint } from '../../constants/defaultValues'


export const slice = createSlice({
    name: 'menu',
    initialState: {
        containerClassnames: defaultMenuType,
        subHiddenBreakpoint,
        menuHiddenBreakpoint,
        menuClickCount: 0,
        selectedMenuHasSubItems: defaultMenuType==="menu-default" //if you use menu-sub-hidden as default menu type, set value of this variable to false    
    },
    reducers: {
        changeSelectedMenuHasSubItems: (state, action) => {
            state.selectedMenuHasSubItems = action.payload
        },
        changeDefaultClassnames: (state, action) => {
            const strCurrentClasses = action.payload
            state.containerClassnames = strCurrentClasses
        },
        addContainerClassname: (state, action) => {
            
            const { classname, strCurrentClasses } = action.payload
            const newClasses = !strCurrentClasses.indexOf(classname) > -1 ? strCurrentClasses + ' ' + classname : strCurrentClasses;

            state.containerClassnames = newClasses
        },
        clickOnMobileMenu: (state, action) => {

            const strCurrentClasses = action.payload

            const currentClasses = strCurrentClasses ? strCurrentClasses.split(' ').filter(x => x !== '' && x !== 'sub-show-temporary') : '';
            let nextClasses = '';
            if (currentClasses.includes('main-show-temporary')) {
                nextClasses = (currentClasses.filter(x => x !== 'main-show-temporary')).join(' ');
            } else {
                nextClasses = currentClasses.join(' ') + ' main-show-temporary';
            }

            state.containerClassnames = nextClasses
            state.menuClickCount = 0
        },
        setContainerClassnames: (state, action) => {
            let { clickIndex, strCurrentClasses,selectedMenuHasSubItems } = action.payload
            
            const currentClasses = strCurrentClasses ? strCurrentClasses.split(' ').filter(x => x !== '') : '';
            let nextClasses = '';
            if (!selectedMenuHasSubItems) {
                if (currentClasses.includes("menu-default") && (clickIndex % 4 === 0 || clickIndex % 4 === 3)) {
                  clickIndex=1;
                }
                if (currentClasses.includes("menu-sub-hidden") && (clickIndex % 4 === 2)) {
                  clickIndex=0;
                }
                if (currentClasses.includes("menu-hidden") && (clickIndex % 4 === 2 || clickIndex % 4 === 3 )) {
                    clickIndex=0;
                  }
        
              }
        
        
        
            if (clickIndex % 4 === 0) {
                if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-default menu-sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden';
                }
                clickIndex = 0;
            } else if (clickIndex % 4 === 1) {
                if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-default menu-sub-hidden main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary';
                }
            } else if (clickIndex % 4 === 2) {
                if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-default menu-sub-hidden sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary sub-show-temporary';
                }
            } else if (clickIndex % 4 === 3) {
                if (currentClasses.includes('menu-default') && currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-default menu-sub-hidden sub-show-temporary';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden sub-show-temporary';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary';
                }
            }
            if (currentClasses.includes('menu-mobile')) {
                nextClasses += ' menu-mobile';
            }
            
            /* UPDATE STATE */
            state.containerClassnames = nextClasses
            state.menuClickCount = clickIndex
        }
    }
})

// Action creators are generated for each case reducer function
export const { 
    changeSelectedMenuHasSubItems, 
    changeDefaultClassnames, 
    clickOnMobileMenu,      
} = slice.actions

const { 
    addContainerClassname: _addContainerClassname,
    setContainerClassnames: _setContainerClassnames
 } = slice.actions


/* WRAPPERS */
export const addContainerClassname = (classname, strCurrentClasses) => _addContainerClassname({classname, strCurrentClasses})
export const setContainerClassnames = (clickIndex, strCurrentClasses,selectedMenuHasSubItems) => _setContainerClassnames({clickIndex, strCurrentClasses,selectedMenuHasSubItems})

export default slice.reducer